<template> 
  <div class="container" v-if="allBookings" style="min-height: 700px;">
    <div class="row margin-bottom-10 margin-top-20 mybookings-header">
      <div class="col-12">
        <div class="card afas-gold">
          <div class="card-content">
            <h5 class="margin-top-10 margin-bottom-10 white-text">All Bookings</h5>
            <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row calendar-card card margin-bottom-10 ">
          <div class="col-12 card-content">
            <div class="row">
                <div class="input-field col s6">
                    <datepicker v-model="startDate" @input="getBookingsByDateRange"></datepicker>
                </div>
                <div class="input-field col s6">
                    <datepicker v-model="endDate" @input="getBookingsByDateRange"></datepicker>
                </div>
            </div>
        </div>
    </div> 
    <div class="progress" v-if="loading">
        <div class="indeterminate"></div>
    </div>
    <div class="row card margin-top-10" v-if="!loading">
          <div class="col-12 card-content" v-if="locations.length > 0">
            <h6 class="margin-bottom-30">Select an office</h6>
            <button class="btn" :class="{ 'deep-purple': location.selected }" style="margin-left:5px;" v-for="location in locations" :key="location.id" @click="selectLocation(location.name)">{{ location.name }}</button>
          </div>
           <div class="col-12 card-content center" v-if="locations.length < 1">
              <p class="red-text">Er zijn nog geen reserveringen gemaakt voor deze periode.</p>
          </div>
    </div>
    <span v-for="location in locations" :key="location.id">
      <div class="row calendar-card card margin-top-10" v-if="location.selected">
          <div class="col-12 card-content">
                <div class="row">
                    <div class="col-12">
                        <h5>{{ location.name }}</h5>
                    </div>
                    <div class="col-12">
                        <table class="striped highlight responsive-table">
                            <thead>
                                <th style="width: 6rem">Date</th>
                                <th style="width: 16rem">Day</th>
                                <th>Employee</th>
                                <!-- <th>Location</th> -->
                                <th style="width: 4rem">Status</th>
                                <th style="width: 4rem">Actions</th>
                            </thead>
                            <tbody>
                                <tr class="scale-transition" :class="{ 'just-deleted': booking.id == justDeletedId }" v-for="booking in location.bookings" :key="booking.id">
                                    <td :class="{ 'double-booking': booking.double_booking }">{{ booking.date }}</td>
                                    <td :class="{ 'double-booking': booking.double_booking }">
                                        {{ booking.day }} 
                                        <span v-if="!booking.timeslot">(
                                            <span v-if="booking.shift == 1">Full Day</span>
                                            <span v-if="booking.shift == 2">Morning</span>
                                            <span v-if="booking.shift == 3">Afternoon</span>)
                                        </span>
                                        <span v-if="booking.timeslot">
                                            <span>({{ booking.timeslot }})</span>
                                        </span>
                                    </td>
                                    <td :class="{ 'double-booking': booking.double_booking }"><strong>{{ booking.employee }}</strong><span v-if="booking.why" style="font-size: 0.75rem"><br><em>{{ booking.why }}</em></span><span v-if="booking.double_booking" style="font-size: 0.75rem"><br><em>Double Booking (created: {{ booking.created }})</em></span></td>
                                    <!-- <td>{{ booking.location }}</td> -->
                                    <td :class="{ 'double-booking': booking.double_booking }">
                                        <span v-if="booking.approved == true || booking.approved == null" class="new badge teal" data-badge-caption=" ">Approved</span>
                                        <span v-if="booking.approved == false" class="new badge red" data-badge-caption=" ">Not Approved</span>
                                    </td>
                                    <td class="center delete-icon" width="50px"><i v-if="booking.id != justDeletedId" class="material-icons red-text" @click="deleteBookingDialog(booking)">delete</i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </span>
        <v-dialog />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import firebase from "firebase";
export default {
name: 'allBookings',
components: {
    Datepicker
  },
data () {
    return {
        time: new Date(),
        bookings: null,
        selectedBookingToDelete: null,
        justDeletedId: null,
        loading: true,
        startDate: new Date(),
        endDate: new Date(),
        locations: [],
        user: null
    }
  },
  computed: {
      ...mapGetters(['allBookings']),
  },
  methods: {
    ...mapActions(['setAllBookings', 'setAllBookingsByDateRange', 'deleteBooking']),
    goBack() {
        this.$router.go(-1);
    },
    createDatesFromTimestamps(){
        var location_id = 1;
        this.bookings = this.allBookings;
        for(var i = 0; i < this.bookings.length; i++){

            if(!this.bookings[i].date_string) {
                this.bookings[i].date = moment(this.bookings[i].timestamp).format("Do MMM")
                this.bookings[i].day = moment(this.bookings[i].timestamp).format("dddd")
            } else {
                //transform date_string dd-mm-yyyy to mm-dd-yyyy for moment
                var dateParts = this.bookings[i].date_string.split("-");
                this.bookings[i].date_string_adjusted = dateParts[1] + "-" + dateParts[0] + "-" + dateParts[2];

                this.bookings[i].date = moment(this.bookings[i].date_string_adjusted).format("Do MMM")
                this.bookings[i].day = moment(this.bookings[i].date_string_adjusted).format("dddd")
            }

        }
        this.bookings.sort((a, b) => a.timestamp - b.timestamp );
        for(var j = 0; j < this.bookings.length; j++){
            var index = this.locations.findIndex(x => x.name == this.bookings[j].location);
            if(index == -1){
                this.locations.push({ name: this.bookings[j].location, bookings: [this.bookings[j]], id: location_id, selected: false })
                location_id++
            } else {
                this.locations[index].bookings.push(this.bookings[j])
            }
        }


        //check if there are double bookings
        for(var k = 0; k < this.bookings.length; k++){
            for(var l = 0; l < this.bookings.length; l++){
                if(k != l && this.bookings[k].employee != this.bookings[l].employee && this.bookings[k].date_string == this.bookings[l].date_string && this.bookings[k].location == this.bookings[l].location && this.bookings[k].timeslot && this.bookings[k].timeslot == this.bookings[l].timeslot){
                    console.log("DOUBLE BOOKING FOUND found: " + this.bookings[k].employee + " on " + this.bookings[k].date);
                    //mark these bookings in red in the table
                    var index1 = this.locations.findIndex(x => x.name == this.bookings[k].location);
                    var index2 = this.locations[index1].bookings.findIndex(x => x.id == this.bookings[k].id);
                    this.locations[index1].bookings[index2].double_booking = true;
                    this.locations[index1].bookings[index2].created_string = this.bookings[k].created ? moment(this.bookings[k].created).format("Do MMM YYYY, h:mm:ss a") : "Unknown";

                    var index3 = this.locations.findIndex(x => x.name == this.bookings[l].location);
                    var index4 = this.locations[index3].bookings.findIndex(x => x.id == this.bookings[l].id);
                    this.locations[index3].bookings[index4].double_booking = true;
                    this.locations[index3].bookings[index4].created_string = this.bookings[l].created ? moment(this.bookings[l].created).format("Do MMM YYYY, h:mm:ss a") : "Unknown";

                }
            }
        }

        this.loading = false;

    },
    selectLocation(locationName){
        for(var i = 0; i < this.locations.length; i++){
            if(this.locations[i].name == locationName){
                console.log(1)
                this.locations[i].selected = true;
            } else {
                console.log(2)
                this.locations[i].selected = false;
            }
        }
    },
    deleteBookingDialog(booking) {
        this.selectedBookingToDelete = booking,
        this.$modal.show('dialog', {
            title: 'Weet je het zeker?',
            text: 'Weet je zeker dat je de boeking van <strong class="teal-text">' + booking.day + " " + booking.date + "</strong> in <strong class='teal-text'>" + booking.location + "</strong> wilt verwijderen?",
            buttons: [
                {
                title: 'Annuleren',
                    handler: () => {
                        this.$modal.hide('dialog')
                    }
                },
                {
                title: 'Bevestigen',
                    handler: async () => {
                        await this.deleteBooking(booking.id);
                        await this.setAllBookings();
                        this.justDeletedId = this.selectedBookingToDelete.id
                        this.$modal.hide('dialog')
                        setTimeout(()=>{
                            this.justDeletedId = null
                            // this.bookings = this.bookings.filter(x => x.id != this.selectedBookingToDelete.id);
                            console.log(this.selectedBookingToDelete)
                            var index = this.locations.findIndex(x => x.name == this.selectedBookingToDelete.location);
                            this.locations[index].bookings = this.locations[index].bookings.filter(x => x.id != this.selectedBookingToDelete.id);
                        }, 2000)
                    }
                }
            ]
        })
    },
    async getBookingsByDateRange(){
        this.loading = true;
        this.locations = [];
        var dates = {
            start: this.startDate.getTime(),
            end: this.endDate.getTime()
        }
        await this.setAllBookingsByDateRange(dates);
        this.createDatesFromTimestamps()
    }
  },
  async mounted() {
        var dates = {
            start: this.startDate.getTime(),
            end: this.endDate.getTime() + 604800000
        }
         var firebaseUser = await firebase.auth().currentUser;
        this.user = firebaseUser;
        await this.setAllBookingsByDateRange(dates);
        this.createDatesFromTimestamps();
  }
}
</script>

<style scoped>

    .calendar-card {
        position: relative;
    }

    .mybookings-header .back-button {
        position: absolute;
        top: 15px;
        right: 15px;;
    }

    .delete-icon {
        cursor: pointer;
    }

    .delete-icon:hover {
        color: grey;
    }

    .just-deleted {
        text-decoration: line-through;
        background-color: rgba(255, 0, 0, 0.3);
    }

    .double-booking {
        background-color: rgba(0, 247, 255, 0.3);
    }

</style>


// WEBPACK FOOTER //
// src/components/bookings/AllBookings.vue